import Cookies from 'universal-cookie';
import { CART_ID } from 'global/constants';

export default function useCartId() {
  const cookies = new Cookies();

  return cookies.get(CART_ID) ?? null;
}
